module.exports = __webpack_public_path__ + "static/media/Lisa Inkley Headshot.218dc726.jpeg";